<mat-card
  class="move-tank-wrapper"
  [class.form-is-busy]="formIsBusy === true"
>
  <mat-card-header>
    <mat-card-title>
      <span *ngIf="uniqueId"> {{ 'MoveForms.TankMove.MoveTank' | translate }} </span>
      <span *ngIf="!uniqueId">{{ 'MoveForms.TankMove.MoveTanks' | translate }} </span>
      <span class="spacer">
      </span>
      <button
        mat-icon-button
        matTooltip="{{ 'General.Close' | translate }}"
        (click)="onCloseButtonClick()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
    <mat-card-subtitle>
      <div class="progress-bar-wrapper" [hidden]="!isLoading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
      <mat-divider class="divider" *ngIf="!isLoading"></mat-divider>
      <ng-container *ngIf="hasAssociatedTanks">
        <app-tap-alert [title]="'MoveForms.TankMove.AssociateTankWarning'"></app-tap-alert>
      </ng-container>
    </mat-card-subtitle>
  </mat-card-header>

  <mat-card-content class="tank-move-form">
    <div class="dual-tree-form-wrapper">
      <!-- Move To Dual-Tree-View-List Form container-->
      <ng-container
        *ngIf="formMode === 'location' || formMode === 'organization'"
      >
        <app-dual-treeview #dualTreeView
          [treeViewData]="treeViewDataManager"
          [dataMapper]="mapToTreeNode"
          [batchLoadLocations]="batchLoadLocationsFn"
          [batchLoadTanks]="batchLoadTanksFn"
          [loadReceivingLocationsOnly]="loadReceivingLocationsOnlyFn"
          (dataLoadStarting)="onTreeDataLoading()"
          (dataLoadCompleted)="onTreeDataLoaded()"
          [searchTextPlaceholder]="
            'MoveForms.TankMove.SearchOrgLoc' | translate
          "
          [leftFilterToggleLabel]="
            'MoveForms.TankMove.FilterHeader' | translate
          "
          [rightTreeHeader]="'MoveForms.DualTree.TanksToBeMoved' | translate"
          [rightTreeHeaderCount]="selectedTankCount"
          [showOrgChildCounts]="false"
          (rightTreeDataChanged)="onDualTreeView_RightChanges($event)"
        ></app-dual-treeview>
      </ng-container>

      <!-- Assocaited Tank Move Dual-List Form container-->
      <ng-container *ngIf="formMode === 'tank'">
        <div class="dual-list-wrapper" fxLayout="row">
          <div class="dual-list-groupa">
            <h5
              title="{{
                'MoveForms.TankMove.OtherAssocaitedTankListHeader' | translate
              }}"
            >
              {{
                'MoveForms.TankMove.OtherAssocaitedTankListHeader' | translate
              }}
            </h5>
            <ejs-listbox
              [hidden]="isLoading"
              [dataSource]="associatedTanks"
              [fields]="fields"
              [toolbarSettings]="toolbarSettings"
              id="listboxA"
              #listboxA
              scope="#listboxB"
              (actionBegin)="onActionBegin($event)"
              (actionComplete)="onActionComplete($event)"
              [itemTemplate]="itemTemplate"
            >
            </ejs-listbox>
            <div *ngIf="isLoading" class="isLoadingSpinner">
              <mat-spinner></mat-spinner>
            </div>
          </div>
          <div class="dual-list-groupb">
            <h5>{{ 'MoveForms.TankMove.TanksToBeMovedHeader' | translate }}</h5>
            <ejs-listbox
              [dataSource]="selectedTanks"
              [hidden]="isLoading"
              [fields]="fields"
              id="listboxB"
              #listboxB
              (actionBegin)="onActionBegin($event)"
              [itemTemplate]="itemTemplate"
            >
            </ejs-listbox>
            <div *ngIf="isLoading" class="isLoadingSpinner">
              <mat-spinner></mat-spinner>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="move-to-location-wrapper">
      <app-move-to-location-form
        [formVM]="locationFormVM"
        (locationChanged)="onLocationChanged($event)"
      ></app-move-to-location-form>
    </div>
  </mat-card-content>

  <!-- What the move will do to affiliation, kept in step with the selected tanks and the destination:
       one sentence per group of tanks, and not shown when no tank's affiliation would change. The
       same sentences as Move Locations, which does the same write, and the MOVE dialog states the
       rule beside its permissions and rate-plan warnings.

       Deliberately OUTSIDE mat-card-content, as on Move Locations. Inside it the alert would sit
       below a scrolling tree and the destination picker, so the one thing warning about an
       unasked-for side effect would be the one thing you had to go looking for. `shrink-0` keeps it
       whole when the selection grows.

       `linkedItems`, not `items`: these carry counts, and `items` puts every entry through the
       translate pipe - see the note on TapAlertComponent. -->
  <div class="mt-4 shrink-0 px-4" *ngIf="affiliationPreviewLines.length > 0">
    <app-tap-alert
      type="warning"
      title="MoveForms.LocationMove.Affiliation.PreviewTitle"
      [linkedItems]="affiliationPreviewLines"
    >
    </app-tap-alert>
  </div>

  <mat-card-actions>
    <button
      mat-button
      (click)="onCancelButtonClick()"
      [disabled]="moveInProgress"
    >
      {{ 'Dialog.Cancel' | translate }}
    </button>
    <button
      mat-raised-button
      class="add-new-item-button move-button"
      (click)="onMoveButtonClick()"
      [disabled]="!isMoveButtonEnabled"
    >
      {{ 'MoveForms.TankMove.MoveSelectedTanks' | translate }}
    </button>
  </mat-card-actions>
</mat-card>

<ng-template #itemTemplate let-data>
  <div class="item-wrapper">
    <div
      class="name"
      [class.accent]="data?.isAssociatedTank && data?.isDifferent"
    >
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="24.000000pt" height="24.000000pt" viewBox="0 0 300.000000 300.000000" preserveAspectRatio="xMidYMid meet" *ngIf="data?.deviceCategory == 3">
      <g transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
      <path d="M1552 2448 c-8 -8 -12 -50 -12 -124 0 -65 -4 -115 -10 -119 -6 -4 -10 -76 -10 -183 l0 -177 -268 -103 c-147 -57 -289 -112 -315 -123 l-48 -19 2 156 c1 105 -2 159 -10 167 -7 7 -11 54 -11 128 0 99 -3 118 -16 123 -35 14 -44 -12 -44 -130 0 -64 -4 -115 -10 -119 -6 -4 -10 -76 -10 -184 l0 -178 -40 -18 c-22 -10 -46 -27 -53 -39 -19 -28 -32 -304 -17 -350 9 -27 44 -55 214 -170 168 -114 211 -139 248 -143 38 -5 69 4 212 61 92 36 172 66 177 66 6 0 36 -18 68 -39 37 -25 65 -38 78 -35 12 4 44 -13 96 -51 61 -45 78 -63 87 -93 6 -22 10 -180 10 -394 0 -232 4 -358 10 -358 13 0 13 689 1 744 -11 46 -42 80 -127 137 -35 24 -64 50 -64 57 0 32 34 20 116 -39 130 -93 124 -67 124 -521 0 -256 3 -378 10 -378 8 0 10 125 8 393 -3 456 3 429 -117 511 -54 38 -70 54 -73 77 -3 16 -1 28 3 27 4 -2 57 -38 118 -80 95 -67 111 -83 120 -115 7 -24 11 -187 11 -425 0 -252 4 -388 10 -388 13 0 13 749 1 803 -12 53 -34 73 -177 169 -68 46 -123 86 -124 90 0 4 9 12 19 18 17 9 41 -4 152 -82 73 -51 142 -106 153 -121 20 -28 21 -41 24 -453 2 -277 6 -424 13 -424 7 0 9 141 7 418 -3 376 -5 420 -21 449 -15 28 -15 32 -2 27 43 -17 45 -43 45 -479 0 -270 3 -415 10 -415 7 0 10 145 10 415 0 353 -2 420 -15 445 -9 18 -57 58 -121 101 -87 58 -103 73 -93 85 6 8 15 14 20 14 5 0 56 -32 114 -72 84 -58 107 -78 120 -110 13 -32 15 -103 15 -458 0 -282 3 -420 10 -420 7 0 10 143 8 439 -3 427 -4 440 -24 468 -17 23 -126 105 -200 148 -9 6 -15 16 -13 23 3 9 15 5 38 -12 24 -18 39 -23 55 -17 17 6 38 -4 104 -51 46 -33 87 -71 92 -84 5 -13 10 -196 11 -407 1 -210 4 -410 6 -444 l5 -63 34 0 35 0 -3 468 c-3 545 6 498 -124 587 -66 45 -83 62 -86 86 -3 16 -3 29 -1 29 3 0 19 -11 37 -25 21 -16 44 -25 63 -23 36 2 138 -65 153 -102 9 -21 40 -763 40 -957 l0 -63 41 0 41 0 -6 138 c-3 75 -11 304 -17 507 -13 437 -12 432 -108 492 -49 31 -60 43 -61 65 0 16 -10 34 -26 47 l-26 20 35 15 c20 8 40 23 46 34 16 30 14 300 -2 332 -12 23 -278 214 -392 281 -66 38 -105 37 -212 -6 -48 -19 -88 -35 -90 -35 -2 0 -3 69 -3 154 0 93 -4 157 -10 161 -6 4 -10 54 -10 119 0 109 -7 136 -35 136 -6 0 -16 -5 -23 -12z m28 -166 c0 -37 4 -72 9 -77 5 -6 11 -81 13 -167 3 -156 3 -157 -20 -168 -13 -5 -27 -10 -32 -10 -6 0 -10 64 -10 155 0 123 3 163 16 187 11 20 15 49 12 89 -2 33 0 59 5 59 4 0 7 -31 7 -68z m-730 -162 c0 -16 -4 -30 -10 -30 -11 0 -14 43 -3 53 11 12 13 8 13 -23z m0 -124 c0 -41 5 -78 10 -81 6 -4 10 -70 10 -165 l0 -158 -30 -11 -30 -10 0 169 c0 102 4 171 10 175 6 3 10 40 10 81 0 43 4 74 10 74 6 0 10 -31 10 -74z m1237 -202 c106 -71 194 -135 198 -143 3 -8 0 -20 -7 -27 -22 -22 -1074 -434 -1107 -434 -24 0 -77 31 -219 126 -217 147 -231 158 -217 180 6 9 251 111 545 225 446 175 542 209 576 206 32 -3 79 -30 231 -133z m221 -326 l-3 -132 -34 -23 c-28 -19 -35 -20 -46 -9 -8 7 -34 26 -59 42 -41 26 -46 33 -46 65 0 20 -2 38 -5 41 -3 3 -70 -22 -148 -54 -168 -70 -441 -183 -584 -240 l-101 -42 -4 -69 c-2 -38 0 -71 3 -73 3 -2 37 10 75 26 81 34 91 35 122 12 23 -18 22 -18 -137 -80 -88 -34 -174 -62 -191 -62 -22 0 -80 34 -217 126 -104 70 -196 134 -205 143 -14 13 -17 41 -20 164 -2 81 0 147 3 147 4 0 11 -6 17 -13 6 -7 96 -70 200 -141 155 -105 197 -129 234 -133 40 -5 97 16 579 207 294 116 538 216 544 221 22 21 25 2 23 -123z m-208 -60 c0 -17 -3 -19 -9 -9 -7 11 -19 9 -69 -10 -57 -22 -61 -26 -65 -59 -4 -32 -4 -32 -3 5 1 39 2 40 66 67 79 33 80 33 80 6z m-32 -49 c-7 -5 -19 -7 -26 -4 -7 3 -26 -2 -43 -10 -16 -9 -29 -11 -29 -6 0 13 53 41 75 41 10 0 13 -5 9 -12 -4 -8 -3 -10 2 -5 5 5 10 13 10 18 3 21 7 23 11 5 3 -10 -1 -22 -9 -27z m-134 -16 c4 -9 2 -21 -4 -27 -7 -7 -10 -5 -10 7 0 22 2 22 -75 -9 -55 -22 -65 -30 -65 -50 0 -13 -4 -24 -10 -24 -5 0 -10 7 -10 15 0 21 -16 19 -87 -11 -56 -24 -63 -30 -63 -56 0 -32 -19 -38 -27 -8 -7 25 -5 25 -86 -7 l-68 -28 3 -49 3 -48 -70 -28 -70 -28 -3 51 c-2 40 1 54 14 64 10 7 20 10 23 7 3 -3 -2 -10 -12 -15 -12 -7 -17 -22 -17 -49 0 -22 2 -40 4 -40 2 0 29 11 60 25 54 24 56 26 56 65 0 31 -3 38 -15 34 -8 -4 -15 -2 -15 2 0 8 501 220 526 223 7 0 15 -7 18 -16z m176 -18 c0 -11 7 -14 28 -10 19 4 15 -1 -16 -16 -52 -24 -51 -36 1 -14 38 16 79 20 90 8 4 -4 -14 -18 -40 -32 -38 -20 -49 -32 -51 -55 -3 -24 -12 -32 -62 -53 -47 -21 -60 -31 -63 -52 -3 -22 -4 -21 -6 7 -1 30 3 35 42 52 51 23 43 26 -12 4 -26 -10 -43 -25 -50 -42 l-9 -27 -1 31 c-1 28 4 33 45 49 25 9 43 19 40 22 -3 3 -25 -3 -50 -12 -63 -24 -79 -8 -19 20 60 29 51 32 -17 5 -68 -27 -63 -11 7 22 l57 26 40 -34 c42 -36 52 -37 41 -5 -8 25 -108 98 -113 82 -2 -6 -8 -11 -13 -11 -6 0 -5 9 1 21 l11 20 35 -20 c19 -12 41 -21 47 -21 7 0 4 5 -5 11 -10 5 -15 16 -12 24 8 20 54 20 54 0z m-245 -33 c-20 -17 -65 -32 -65 -21 0 5 10 14 23 19 28 11 54 13 42 2z m104 -13 c18 -11 32 -22 30 -23 -2 -2 -27 -14 -56 -26 l-52 -22 -37 22 -36 23 53 23 c67 28 58 28 98 3z m247 -35 c-11 -8 -26 -14 -33 -14 -7 0 -13 -5 -13 -11 0 -7 7 -8 18 -4 9 5 34 9 55 11 46 4 52 -21 7 -31 -23 -5 -30 -12 -30 -31 0 -15 -6 -24 -15 -24 -8 0 -15 9 -15 20 0 13 -5 18 -15 14 -11 -4 -15 1 -16 17 -1 17 -3 19 -6 7 -7 -26 -23 -22 -23 6 0 18 10 28 47 44 51 22 71 20 39 -4z m-536 -32 c-19 -7 -41 -21 -48 -30 -13 -16 -14 -15 -10 3 3 21 66 57 83 47 5 -3 -6 -12 -25 -20z m130 -12 l44 -29 -39 -17 c-22 -9 -48 -20 -57 -25 -10 -6 -18 -6 -18 -1 0 5 18 17 40 27 22 10 39 20 37 22 -2 2 -25 -6 -51 -17 l-47 -21 -35 22 -36 22 53 23 c30 13 56 23 59 24 3 0 25 -13 50 -30z m81 -10 c38 -27 59 -48 59 -60 0 -11 -4 -20 -8 -20 -5 0 -37 27 -72 60 -74 69 -65 78 21 20z m-267 -63 c17 -13 14 -15 -38 -37 -56 -22 -57 -22 -91 -4 -19 10 -32 20 -29 23 3 3 28 15 57 27 52 22 61 21 101 -9z m72 7 c47 -28 53 -38 28 -48 -17 -7 -84 42 -84 62 0 17 5 16 56 -14z m178 17 c5 -8 -81 -51 -103 -51 -26 0 -7 19 37 38 54 24 59 25 66 13z m236 -5 c0 -7 -16 -21 -35 -30 -22 -11 -35 -24 -35 -36 0 -18 -20 -30 -20 -12 0 4 -3 17 -6 29 -5 18 1 25 38 41 53 25 58 26 58 8z m-220 -24 c0 -9 -91 -44 -98 -37 -5 4 75 44 91 45 4 0 7 -4 7 -8z m-502 -8 c12 -4 22 -13 22 -20 0 -19 -10 -17 -40 6 -26 20 -21 24 18 14z m272 -13 c0 -9 -110 -54 -117 -47 -4 4 94 53 110 55 4 1 7 -3 7 -8z m255 0 c-15 -14 -85 -41 -85 -32 0 4 15 15 33 24 36 17 67 23 52 8z m-531 -29 c3 -5 -10 -16 -29 -25 -35 -16 -35 -16 -35 6 0 32 19 48 41 36 10 -5 20 -13 23 -17z m122 -12 c27 -19 44 -39 44 -50 0 -25 -3 -25 -49 6 -23 14 -41 36 -44 50 -2 13 -2 24 0 24 2 0 24 -14 49 -30z m183 6 c-17 -15 -103 -44 -117 -39 -12 5 -1 14 43 34 36 16 64 24 69 18 5 -5 8 -10 5 -13z m251 14 c0 -5 -9 -10 -20 -10 -11 0 -25 -9 -32 -19 -6 -10 -18 -17 -25 -14 -22 9 -15 20 25 36 45 19 52 20 52 7z m-250 -39 c0 -5 -20 -17 -44 -26 -35 -13 -43 -21 -39 -36 3 -10 0 -19 -6 -19 -12 0 -15 29 -3 46 4 6 25 18 47 27 49 20 45 19 45 8z m30 -20 c0 -4 -20 -16 -45 -25 -33 -13 -45 -23 -45 -38 0 -12 -3 -19 -6 -15 -16 16 8 56 43 70 45 19 53 20 53 8z m20 -31 c0 -13 -5 -18 -15 -13 -18 6 -55 -23 -55 -44 0 -7 -4 -13 -10 -13 -5 0 -10 11 -10 25 0 21 9 30 43 45 23 11 43 20 45 20 1 0 2 -9 2 -20z"/>
      <path d="M1647 1674 c-13 -13 -7 -42 9 -48 9 -3 30 -6 47 -6 78 1 74 53 -4 58 -25 2 -48 0 -52 -4z"/>
      <path d="M1465 1596 c-41 -30 22 -68 78 -47 34 13 35 39 1 51 -35 14 -57 12 -79 -4z"/>
      <path d="M1819 1600 c-11 -8 -10 -12 6 -24 45 -33 71 -44 84 -37 10 6 1 17 -31 39 -30 21 -49 28 -59 22z"/>
      <path d="M1700 1551 c0 -15 81 -63 97 -57 12 5 5 14 -26 36 -40 29 -71 39 -71 21z"/>
      <path d="M1270 1520 c-12 -7 -12 -13 -4 -27 19 -31 114 -29 114 2 0 30 -76 47 -110 25z"/>
      <path d="M1593 1512 c-7 -4 6 -18 36 -39 32 -20 53 -28 62 -23 7 5 11 10 9 12 -15 11 -90 58 -92 58 -2 0 -8 -4 -15 -8z"/>
      <path d="M1480 1463 c0 -5 21 -21 46 -37 59 -37 83 -21 25 17 -39 26 -71 35 -71 20z"/>
      <path d="M1370 1421 c0 -12 76 -61 95 -61 26 0 17 16 -25 44 -40 26 -70 34 -70 17z"/>
      <path d="M2175 1436 c-20 -30 -6 -66 25 -66 27 0 57 47 43 69 -17 26 -50 25 -68 -3z"/>
      <path d="M740 1297 c0 -14 39 -41 48 -33 6 7 -27 46 -40 46 -4 0 -8 -6 -8 -13z"/>
      <path d="M810 1252 c0 -5 9 -17 20 -27 19 -18 20 -17 20 2 0 12 -7 24 -16 27 -21 8 -24 8 -24 -2z"/>
      <path d="M740 1237 c0 -14 39 -41 48 -33 6 7 -27 46 -40 46 -4 0 -8 -6 -8 -13z"/>
      <path d="M880 1206 c0 -9 9 -20 20 -26 16 -8 20 -8 20 4 0 9 -9 20 -20 26 -16 8 -20 8 -20 -4z"/>
      <path d="M810 1197 c0 -14 20 -37 32 -37 16 0 8 25 -12 38 -16 10 -20 10 -20 -1z"/>
      <path d="M946 1157 c2 -7 13 -18 24 -25 16 -10 20 -10 20 1 0 17 -20 37 -37 37 -7 0 -10 -6 -7 -13z"/>
      <path d="M880 1146 c0 -9 9 -20 20 -26 16 -8 20 -8 20 4 0 9 -9 20 -20 26 -16 8 -20 8 -20 -4z"/>
      <path d="M1010 1117 c0 -14 39 -41 48 -33 6 7 -27 46 -40 46 -4 0 -8 -6 -8 -13z"/>
      <path d="M940 1101 c0 -5 11 -16 25 -25 19 -13 25 -13 25 -3 0 7 -5 18 -12 25 -14 14 -38 16 -38 3z"/>
      <path d="M1010 1055 c0 -15 38 -40 47 -31 7 7 -26 46 -39 46 -4 0 -8 -7 -8 -15z"/>
      </g>
      </svg>{{ data?.name }}
    </div>
    <div class="additional-item-details">
      <div
        appAuthorization
        [policy]="securityPolicies.RequireSuperUser"
        [policyOptions]="{ policyAction: Hide }"
        class="billable-org"
      >
        - {{ data?.billableOrgName }}
      </div>
      <div class="org">- {{ data?.orgName }}</div>
      <div class="location">- {{ data?.locationName }}</div>
    </div>
  </div>
</ng-template>
